import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import logo from "../assets/logo_icon.png";

const navItems = [
  { key: "home", label: "Home" },
  { key: "about_us", label: "About Us" },
  { key: "services", label: "Services" },
];

export default function TopBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  return (
    <header className="TopBar topbar-modern">
      <div className="body">
        <div className="container topbar-modern-inner">
          <button className="topbar-brand" onClick={() => goTo("home")} aria-label="Go to home">
            <img src={logo} className="topbar-brand-logo mDesktopOnly" alt="Franno logo" />
            <img src={logo} className="topbar-brand-logo-mobile mMobileOnly" alt="Franno logo" />
          </button>

          <nav className="DesktopMenu topbar-modern-menu d-none d-md-flex align-self-center mNoMargin mNoPadding mDesktopOnly">
            {navItems.map((item) => {
              const isActive = appContext.navItem === item.key;
              return (
                <button
                  key={item.key}
                  className="mMenuItem topbar-link px-3"
                  data-active={isActive}
                  onClick={() => goTo(item.key)}
                >
                  {item.label}
                </button>
              );
            })}
            <button className="topbar-cta ms-2" onClick={() => goTo("contact_us")}>Contact Us</button>
          </nav>

          <button className="topbar-mobile-toggle d-inline-flex d-md-none mMobileOnly" aria-label="Open menu" onClick={appContext.openSideBar}>
            <MdMenu size={30} />
          </button>
        </div>
      </div>
    </header>
  );
}
